import { OrderActionTypes } from './constants';
import { GetOrdersParams } from 'helpers/api/orders';

export type OrderActionType = {
    type:
        | OrderActionTypes.API_RESPONSE_SUCCESS
        | OrderActionTypes.API_RESPONSE_ERROR
        | OrderActionTypes.GET_ORDERS
        | OrderActionTypes.GET_ORDER_DETAILS;
    payload: {} | string;
};

// Common success
export const orderApiResponseSuccess = (actionType: string, data: any): OrderActionType => ({
    type: OrderActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

// Common error
export const orderApiResponseError = (actionType: string, error: string): OrderActionType => ({
    type: OrderActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

// Get paginated/filtered orders list
export const getOrdersAction = (params: GetOrdersParams): OrderActionType => ({
    type: OrderActionTypes.GET_ORDERS,
    payload: params,
});

// Get a single order by ID
export const getOrderDetailsAction = (orderId: string): OrderActionType => ({
    type: OrderActionTypes.GET_ORDER_DETAILS,
    payload: { orderId },
});
